export default __webpack_public_path__ + "static/media/vip-icon.1be7fa19.webp";